import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import classNames from 'classnames';
import {siteLocale, siteUrl} from '../../lib/constants';

import './Link.scss';

// eslint-disable-next-line no-script-url
const noopStr = 'javascript:;';
const disableInternalLinks = (process.env.REACT_APP_MODE === 'bookends') || false;

class Link extends Component {
  static defaultProps = {
    isInternal: false,
    theme: 'default'
  }

  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
    const {
      onClick,
      disabled
    } = this.props;

    if (disabled) {
      e.stopPropagation();
      e.preventDefault();
    } else {
      if (onClick) {
        onClick(e)
      }
    }
  }

  handleHover = (e) => {
    const {
      onHover,
      disabled
    } = this.props;

    if (disabled) {
      e.stopPropagation();
      e.preventDefault();
    } else {
      if (onHover) {
        onHover(e)
      }
    }
  }

  render() {
    const baseClassName = 'pb-link';
    let href = this.props.href 

    const {
      children,
      fullWidth,
      parentClassName,
      shouldOpenNewPage,
      theme,
      title,
      legend,
      disabled,
      normal,
      onClick,
      tabIndex,
      noTextDecoration,
      newEl,
      isRtl,
      hidden,
      noSitelLocale
    } = this.props;
    

    let { isInternal } = this.props;

    if (disableInternalLinks || onClick) {
      isInternal = false;
    }
    
    
        
    if (href){
       let domain = siteUrl.find(url => href.startsWith(url));
       let newHref = domain ?  href.replace(domain,'') : href;
       newHref = (newHref.startsWith(`/${siteLocale}`) || newHref.startsWith('http') || newHref.startsWith('#') || newHref.startsWith('mail')) ? newHref : `/${siteLocale}${newHref}`
       href = noSitelLocale
                 ? 
                 href
                 :
                 newHref
    }
    if (!href) {
      href = noopStr;      
    }

    let legendEl;
    if (legend) {
      legendEl = <span className={`${baseClassName}__legend`}>{legend}</span>;
    }

    const classes = {
      [baseClassName]: true,
      [`${baseClassName}--${theme}`]: theme,
      [`${baseClassName}--full-width`]: fullWidth,
      [`${baseClassName}--disabled`]: disabled,
      [`${baseClassName}--hidden`]: hidden,
      [`${baseClassName}--normal`]: normal,
      [`${baseClassName}--rtl`]: isRtl,
      [`${baseClassName}--no-text-decoration`]: noTextDecoration,
      [parentClassName]: parentClassName
    };

    if (isInternal && !disabled) {

      return (
        <RouterLink
          to={href.replace(`/${siteLocale}`, '')}
          className={classNames(classes)}
          title={title}
          tabIndex={tabIndex}
        >
          {newEl}
          {children}
          {legendEl}
        </RouterLink>
      );
    } else if (shouldOpenNewPage) {
      return (
        <a
          href={href}
          className={classNames(classes)}
          title={title}
          target="_blank"
          onClick={this.handleClick}
          onMouseOver={this.handleHover}
          tabIndex={tabIndex}
        >
          {newEl}
          {children}
          {legendEl}
        </a>
      )
    } else {
      return (
        <a
          href={href}
          className={classNames(classes)}
          title={title}
          onClick={this.handleClick}
          onMouseOver={this.handleHover}
          tabIndex={tabIndex}
        >
          {newEl}
          {children}
          {legendEl}
        </a>
      );
    }
  }
}

Link.propTypes = {
  isInternal: PropTypes.bool,
  shouldOpenNewPage: PropTypes.bool,
  // children: PropTypes.node.isRequired,
  parentClassName: PropTypes.string,
  /* Default theme is default */
  theme: PropTypes.oneOf([
    'default',
    'light',
    'info',
    'danger',
    'warning',
    'success',
    'dark',
    'fab',
    'regular',
    'ticker',
    'inherit',
    'csf',
  ]),
  title: PropTypes.string,
  fullWidth: PropTypes.bool,
  legend: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
};

export default Link;



// WEBPACK FOOTER //
// ./src/components/Link/Link.jsx